export enum roleModel {
  SINGULAR = 'Berechtigung anderer Nutzer',
  PLURAL = 'Berechtigung anderer Nutzer',
  ROUTE = '/berechtigungen',
  ICON = 'mdi-account-multiple-check',
  ITEM_KEY = 'role',
  ITEM_KEY_UPDATE = 'roles'
}
